/** KeyboardEvent.key values. */
export const KEY_ENTER = "Enter";
export const KEY_ESCAPE = "Escape";
export const KEY_TAB = "Tab";
export const KEY_SPACE = " ";
export const KEY_HOME = "Home";
export const KEY_END = "End";
export const KEY_ARROW_UP = "ArrowUp";
export const KEY_ARROW_DOWN = "ArrowDown";
export const KEY_ARROW_LEFT = "ArrowLeft";
export const KEY_ARROW_RIGHT = "ArrowRight";
export const KEY_BACKSPACE = "Backspace";
